<template>
    <div class="meeting_login_container">
        <div class="tapd_login_container">
            <div class="tapd_login"></div>
            <div class="tapd_login_title">TAPD</div>
        </div>
        <div class="button-container">
            <div @click="handleClickMeetingLogin" class="meeting_login_button" :disabled="!isChecked">
                <div class="meeting_icon"></div>{{$_t('用腾讯会议登录')}}</div>
            <div @click="handleClickNormalLogin" class="normal_login_button" :disabled="!isChecked">{{$_t('手机号登录')}}</div>
        </div>
        <div class="protocol-container">
            <el-checkbox v-model="isChecked">
            </el-checkbox>{{$_t('已阅读并同意')}}<label for="agree_terms">
                <a :href="basePath + 'home/protocol'">{{$_t('《TAPD服务协议》')}}</a>
                <a :href="basePath + 'home/privacy'">{{$_t('《TAPD隐私政策》')}}</a>
            </label>
        </div>
    </div>
</template>


<script>
import * as wemeet from "@tencent/wemeet-js-sdk";

import api from '@/api';
import { mapActions } from 'vuex';
import wemeet_error from "@/util/wemeet";

const basePathMap = {
    'pc': process.env.VUE_APP_TAPD_BASE_PATH,
    'h5': process.env.VUE_APP_TAPDM_BASE_PATH
}
const allUrlMap = {
    'pc': {
        'story': '/prong/stories/view/',
        'bug': '/bugtrace/bugs/view/',
        'task': '/prong/tasks/view/'
    },
    'h5': {
        'story': '/workitems/story/',
        'bug': '/workitems/bug/',
        'task': '/workitems/task/'
    }
};


export default {
    name: 'home',
    path: 'home',
    async beforeMount() {
        try {
            wemeet.permission.requestAgentAuthCode({ sdkId: process.env.VUE_APP_MEETING_SDK_ID }).then(async (res) => {
                const authCode = res.authCode;
                const jsTicket = await api.user.jsTicket(authCode, process.env.BASE_URL);
                console.log(JSON.stringify(jsTicket), 'jsTicket');
                // eslint-disable-next-line eqeqeq
                if (process.env.VUE_APP_IS_CLOUD == 1) {
                    await wemeet.permission.agentConfig({
                        sdkId: jsTicket['sdkId'],
                        corpId: jsTicket['corpId'],
                        signature: jsTicket['signature'],
                        nonceStr: jsTicket['nonceStr'],
                        timestamp: jsTicket['timestamp']
                    });
                } else {
                    await wemeet.permission.config({
                        sdkId: jsTicket['sdkId'],
                        corpId: jsTicket['corpId'],
                        signature: jsTicket['signature'],
                        nonceStr: jsTicket['nonceStr'],
                        timestamp: jsTicket['timestamp']
                    });
                }
                // 如果已经包含了state变量，则不需要再次登录了
                if (!this.$route.query.state) {
                    wemeet.permission.requestAgentAuthCode({ sdkId: process.env.VUE_APP_MEETING_SDK_ID }).then((resp) => {
                        console.log('home requestAgentAuthCode', resp.authCode, JSON.stringify(this.$route.query));
                        this.setCode(resp.authCode)
                        this.login({ type: 'meeting_webview', options: this.$route.query });
                    })
                }
            }
            ).catch(async (err) => {
                wemeet_error(err);
            })
        } catch (error) {
            console.log('error', error);
        }

    },
    data() {
        return {
            basePath: process.env.VUE_APP_TAPD_BASE_PATH,
            authCode: '',
            login_url: basePathMap['pc'] + 'cloud_logins/login',
            isChecked: false,
        }
    },

    methods: {
        getQueryString() {
            const queryString = window.location.hash;
            return queryString ? queryString.substring(3) : '';
        },
        handleCheckboxChange(event) {
            this.isChecked = event.target.checked;
        },
        // 获取当前会议可能绑定过的tapd workitem
        async getMeetingObjId(meetingId) {
            return await api.user.meetingObjId(meetingId);
        },
        async handleClickMeetingLogin() {
            if (!this.isChecked) {
                return;
            }
            const self = this;
            const { authCode } = await wemeet.permission.requestAgentAuthCode({ sdkId: process.env.VUE_APP_MEETING_SDK_ID });
            wemeet.data.getPhoneNumber({
                success: async ({ code, message, token }) => {
                    console.log('code', code, message, token);
                    // 使用token获取手机号
                    const res = await api.user.getPhone(authCode, token);
                    const redirect_tapd = await self.getRedirectTapd();
                    const { authBy, clientId, oauthUrl, responseType, scope, state, userPhone } = res;
                    const redirect = process.env.BASE_URL + 'oauth_redirect?redirect_tapd=' + encodeURI(redirect_tapd);
                    const params = new URLSearchParams({
                        auth_by: authBy,
                        client_id: clientId,
                        redirect_uri: encodeURI(redirect),
                        response_type: responseType,
                        scope: scope,
                        state: state,
                        phone: userPhone,
                    });
                    // 拼接url
                    const authUrl = `${oauthUrl}?${params.toString()}`;
                    self.redirectToAuthPage(authUrl);
                },
                fail: ({ code, message }) => {
                    console.log('code', code, message);
                },
            }).catch(e => {
                this.$alert(e.message);
            });

        },
        async handleClickNormalLogin() {
            if (!this.isChecked) {
                return;
            }
            
            const redirect_url = await this.getRedirectTapd();
            const href = this.login_url + '?site=TAPD&&txmeeting=1&&ref=' + encodeURIComponent(redirect_url);
            this.redirectToAuthPage(href);
        },
        isInTencentMeeting() {
            return wemeet.app.isTMWebview();
        },

        async redirectToAuthPage(href) {
            try {
                const position = await wemeet.ui.getWebAppPosition();
                if (position.position !== 1) {
                    await wemeet.ui.changeWebAppPosition({ position: 1 });
                }
            } catch (e) {
                console.log(e);
            } finally {
                location.href = href; // 确保无论发生什么情况都会重定向
            }
        },

        async getRedirectTapd() {
            const meetingInfo = await wemeet.meeting.getCurrMeetingInfo();
            const objectInfo = await this.getMeetingObjId(meetingInfo.meetingId);
            const urlMap = allUrlMap['pc'];
            if (meetingInfo.meetingId) {
                if (objectInfo && objectInfo.workspaceId && objectInfo.objType) {
                    return (this.basePath + objectInfo.workspaceId + urlMap[objectInfo.objType] + objectInfo.objId + '?only_content=1&&show_meeting=0');
                } else {
                    // 没有关联的会议
                    return (this.basePath + 'my_worktable');
                }
            }
            return (this.basePath + 'my_worktable');
        },
        ...mapActions(['login', 'setCode', 'permissions']),
    },
    mounted() {
        this.isChecked = false;
    },
};
</script>


<style lang="less">
.meeting_login_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(0deg, #FAFBFC 32.56%, #EBF5FF 73.05%, #E0EFFF 100%);

    .tapd_login_container {
        .tapd_login {
            width: 90px;
            height: 90px;
            background: url("../assets/img/tapd-login-icon.png");
            background-size: cover;
        }

        .tapd_login_title {
            margin-top: 8px;
            font-family: PingFang TC;
            font-size: 24px;
            font-weight: 600;
            line-height: 24px;
            text-align: center;
        }
    }

    .button-container {
        display: flex;
        flex-direction: column;
        margin-top: 60px;

        div {
            &.meeting_login_button {
                display: flex;
                flex-direction: row;
                width: 286px;
                height: 40px;
                border-radius: 8px;
                font-family: PingFang SC;
                font-size: 14px;
                font-weight: 400;
                line-height: 40px;
                text-align: center;
                background-color: #0D68FF;
                color: #FFFFFF;
                cursor: pointer;
                justify-content: center;
                align-items: center;

                .meeting_icon {
                    background: url("../assets/img/meeting-login-icon.png");
                    background-size: cover;
                    margin-right: 4px;
                    width: 26px;
                    height: 14px;
                }
            }

            &.normal_login_button {
                margin-top: 16px;
                width: 284px;
                height: 38px;
                border-radius: 8px;
                border: 1px;
                font-family: PingFang SC;
                font-size: 14px;
                font-weight: 400;
                line-height: 40px;
                text-align: center;
                border-style: solid;
                border-color: #B0B6C3;
                cursor: pointer;
            }

            &[disabled="disabled"] {
                color: lightgray;
                border-color: lightgray;
                opacity: 0.77;
            }
        }
    }

    .protocol-container {
        margin-top: 16px;
        display: flex;
        flex-direction: row;

        .el-checkbox {
            margin-right: 8px;
            cursor: pointer;

            .el-checkbox__input {

                &.is-checked,
                &.is-focus {
                    .el-checkbox__inner {
                        border-color: #0D68FF;

                        &:hover {
                            border-color: #0D68FF;
                        }
                    }
                }

                &.is-checked {
                    .el-checkbox__inner {
                        background-color: #0D68FF;
                    }
                }
            }
        }

        label {
            font-family: PingFang HK;
            font-size: 12px;
            font-weight: 400;
            line-height: 15px;
            text-align: left;
            color: #000000;

            a {
                color: #006FFF;
                text-decoration: none;
                cursor: pointer;
            }
        }
    }
}
</style>